/* ============
 * Recipes Index
 * ============
 *
 * This page shows the list of recipes.
 */

import { mapGetters, mapMutations } from 'vuex';
import recipeService from './../../../../services/recipe';
import debounce from 'debounce';
import store from './../../../../store';
import SearchMixin from './../../../../mixins/search';
import BridgeHandoffMixin from './../../../../mixins/bridgeHandoff';

export default {
  data() {
    return {
      loading: true,
      sort: '',
      info: 'info',
      primary: 'primary',
      search: '',
    };
  },

  computed: {
    ...mapGetters({
      recipes: 'paginatedRecipes',
      allRecipes: 'allRecipes',
      view: 'getView',
      searchQuery: 'recipeQuery',
      account: 'account',
    }),
    recipesListView() {
      return this.recipes.items.map(recipe => ({
        id: recipe.id,
        name: recipe.name,
        recipeType: recipe.recipeType,
      }));
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },

  mixins: [
    SearchMixin,
    BridgeHandoffMixin,
  ],

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 25);
    },

    view(view) {
      if (view == 'card') {
        this.info = 'info';
        this.primary = 'primary';
      } else {
        this.primary = 'info';
        this.info = 'primary';
      }
    },
  },

  mounted() {
    this.setInnerSidebar([{
        title: this.$t('static.materials.filters.title'),
        options: [{
            title: this.$t('static.materials.filters.active'),
            route: {
              name: 'production.materials.index',
              query: {
                filter: 'active',
              },
            },
          },
          {
            title: this.$t('static.materials.filters.deactivated'),
            route: {
              name: 'production.materials.index',
              query: {
                filter: 'deactivated',
              },
            },
          },
          {
            title: this.$t('static.materials.filters.all'),
            route: {
              name: 'production.materials.index',
              query: {
                filter: 'all',
              },
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.materials.create.title')}`,
          route: {
            name: 'production.materials.create',
          },
        },
      },
      {
        title: this.$t('static.batches.filters.title'),
        options: [{
            title: this.$t('static.batches.filters.notStarted'),
            route: {
              name: 'production.batches.index',
              query: {
                filter: 'notStarted',
              },
            },
          },
          {
            title: this.$t('static.batches.filters.upcoming'),
            route: {
              name: 'production.batches.index',
              query: {
                filter: 'upcoming',
              },
            },
          },
          {
            title: this.$t('static.batches.filters.ongoing'),
            route: {
              name: 'production.batches.index',
              query: {
                filter: 'ongoing',
              },
            },
          },
          {
            title: this.$t('static.batches.filters.completed'),
            route: {
              name: 'production.batches.index',
              query: {
                filter: 'completed',
              },
            },
          },
          {
            title: this.$t('static.batches.filters.all'),
            route: {
              name: 'production.batches.index',
              query: {
                filter: 'all',
              },
            },
          },
        ],
      button: this.bridgeStockWriteBlocked ? null : {
        title: `+ ${this.$t('static.batches.create.title')}`,
        route: {
          name: 'production.batches.create',
        },
      },
      },
      {
        title: this.$t('static.recipes.filters.title'),
        options: [{
          title: this.$t('static.recipes.filters.all'),
          route: {
            name: 'production.recipes.index',
          },
        }, ],
        button: {
          title: `+ ${this.$t('static.recipes.create.title')}`,
          route: {
            name: 'production.recipes.create',
          },
        },
      },
      {
        title: this.$t('static.equipments.title'),
        options: [{
          title: this.$t('static.equipments.filters.all'),
          route: {
            name: 'production.equipments.index',
          },
        }, ],
        button: {
          title: `+ ${this.$t('static.equipments.create.title')}`,
          route: {
            name: 'production.equipments.create',
          },
        },
      },
    ]);

    this.all(this.searchQuery.page, this.searchQuery.limit);
    if (this.view == 'card') {
      this.info = 'info';
      this.primary = 'primary';
    } else {
      this.primary = 'info';
      this.info = 'primary';
    }
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    changeView(view) {
      if (this.info != view) {
        this.primary = this.info;
        this.info = view;
        if (this.info == 'info') {
          store.dispatch('setView', 'card');
        } else {
          store.dispatch('setView', 'list');
        }
      }
    },
    /**
     * Fetches paginated recipes
     *
     * @param  {int} page The page number
     */
    all: debounce(function(page, limit) {
      this.loading = true;

      const query = { page, limit, search: this.searchQuery.search };
      store.dispatch('setRecipeQuery', query);
      this.search = this.searchQuery.search;
      recipeService.items({
          page,
          limit,
          search: this.searchQuery.search,
          filter: this.$route.query.filter,
        })
        .then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
    }, 800),

    onChangeSearch(name, value) {
      store.dispatch('setRecipeQuery', { page: 1, limit: 25, search: value });
      this.all(1, 25);
    },
    /**
     * Go to edit view for recipe group
     *
     * @parObject} recipeGroup The recipe group object
     */
    editRecipe(recipe) {
      this.$router.push({
        name: 'production.recipes.edit',
        params: { id: recipe.id },
      });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/recipes/index/index.js